"use client";
import { PopoverArrow } from "./PopoverArrow.js";
import { PopoverBackdrop } from "./PopoverBackdrop.js";
import { PopoverBody } from "./PopoverBody.js";
import { PopoverClose } from "./PopoverClose.js";
import { PopoverDescription } from "./PopoverDescription.js";
import { PopoverPopup } from "./PopoverPopup.js";
import { PopoverPortal } from "./PopoverPortal.js";
import { PopoverPositioner } from "./PopoverPositioner.js";
import { PopoverRoot } from "./PopoverRoot.js";
import { PopoverTitle } from "./PopoverTitle.js";
import { PopoverTrigger } from "./PopoverTrigger.js";
const Popover = {
    Root: PopoverRoot,
    Trigger: PopoverTrigger,
    Portal: PopoverPortal,
    Backdrop: PopoverBackdrop,
    Positioner: PopoverPositioner,
    Popup: PopoverPopup,
    Body: PopoverBody,
    Arrow: PopoverArrow,
    Title: PopoverTitle,
    Description: PopoverDescription,
    Close: PopoverClose
};
export { Popover };
